import REDUX_STATUS from '../../constants/status'

export default function isLoadedReduxUtil (instance) {
  return instance?.status === REDUX_STATUS.SUCCESS
}
